import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";
import { Link } from "react-router-dom";

export const EMPTY_FORM = {
  patient_name: "", patient_dob: "", patient_gender: "", patient_phone: "", patient_email: "",
  patient_country: "India", patient_city: "", reason: "", consent: false,
};

const Field = ({ label, children }) => (
  <div className="space-y-2"><Label className="text-sm text-slate-700">{label}</Label>{children}</div>
);

export default function PatientForm({ form, setForm }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const cls = "h-12 text-base";
  return (
    <div className="grid sm:grid-cols-2 gap-6">
      <Field label="Patient's full name"><Input className={cls} value={form.patient_name} onChange={set("patient_name")} data-testid="patient-name-input" /></Field>
      <Field label="Date of birth"><Input type="date" className={cls} value={form.patient_dob} onChange={set("patient_dob")} data-testid="patient-dob-input" /></Field>
      <Field label="Gender">
        <select className="h-12 w-full rounded-md border border-input bg-white px-3 text-base" value={form.patient_gender} onChange={set("patient_gender")} data-testid="patient-gender-select">
          <option value="">Select</option><option value="female">Female</option><option value="male">Male</option>
          <option value="other">Other</option><option value="prefer_not_to_say">Prefer not to say</option>
        </select>
      </Field>
      <Field label="Phone / WhatsApp (with country code)"><Input className={cls} placeholder="+91 98xxxxxxxx" value={form.patient_phone} onChange={set("patient_phone")} data-testid="patient-phone-input" /></Field>
      <Field label="Email"><Input type="email" className={cls} value={form.patient_email} onChange={set("patient_email")} data-testid="patient-email-input" /></Field>
      <Field label="Country"><Input className={cls} value={form.patient_country} onChange={set("patient_country")} data-testid="patient-country-input" /></Field>
      <Field label="City"><Input className={cls} value={form.patient_city} onChange={set("patient_city")} data-testid="patient-city-input" /></Field>
      <div className="sm:col-span-2">
        <Field label="What would you like to discuss?">
          <Textarea rows={4} className="text-base" placeholder="Diagnosis, current treatment, questions you have…" value={form.reason} onChange={set("reason")} data-testid="patient-reason-input" />
        </Field>
      </div>
      <label className="sm:col-span-2 flex items-start gap-3 text-sm text-slate-600">
        <Checkbox checked={form.consent} onCheckedChange={(v) => setForm({ ...form, consent: !!v })} data-testid="patient-consent-checkbox" className="mt-0.5" />
        <span>I agree to the <Link to="/terms" className="text-teal-700 underline">Terms</Link> and <Link to="/privacy" className="text-teal-700 underline">Privacy Policy</Link>, and understand this is a teleconsultation, not emergency care.</span>
      </label>
    </div>
  );
}
